class CandidateApplyService {

    async getOpportunitiesByCandidate(id) {
        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/opportunities-by-candidate/${id}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
            },
        });

        return await response.json();
    }

    async apply(id, jobs) {

        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/add-opportunities/${id}`, {
            method: 'PATCH',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
            },
            body: jobs
        });
          
      const data = await response.json();
      return data.items
    }
    
    async  unapply(id, jobs) {
        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/remove-opportunities/${id}`, {
            method: 'PATCH',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify([jobs])
        });
        
        const data = await response.json();
        return data.items
    }


    async getCandidateInterestAreas(id) {
        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/interestareas/${id}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            }
        })

        const data = await response.json()
        return data.items
    }
}
export default new CandidateApplyService()